import { defineComponent  } from "vue";
import type { SetupContext } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import OptionsTvChannelPack from "../OptionsTvChannelPack";
import OptionsTvBox from "../OptionsTvBox";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  components: { OptionsTvChannelPack, OptionsTvBox },
  emits: {
    next: () => true
  },
  setup(_props: any, { emit }: SetupContext) {
    const { t } = useI18n();

    // methods
    const next = () => {
      emit("next");
    };

    return {
      t,
      next
    };
  },
} as any);
